var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-display',{attrs:{"form":_vm.form,"path":_vm.path,"label":_vm.topLabel,"value":""}},[_c('q-checkbox',{attrs:{"label":_vm._f("capitalize")(_vm.bottomLabel),"color":_vm.color,"disable":_vm.form.busy || _vm.disable},on:{"input":_vm.onInput},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f29b506","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/form/VCheckbox.vue
// module id = FTB+
// module chunks = 66